import React, { useState } from 'react'
import { Tooltip, Modal } from 'antd'
import { ISasPropostaOrdemCompra, updatePropostaComercial } from '@app/api/sas/sasProposta'
import { Button, FormDatePicker, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui'
import { UploadMultipleTableTmp, Visibility } from '@app/components'
import { useRecoilState, useRecoilValue } from 'recoil'
import { editandoState, modalAcoesIdState, ordemCompraRodadaNegociacaoIdState, reloadVendorListState } from '../../atoms'
import * as Yup from 'yup';
import { getArquivosDocumentoOrdemCompraByOc } from '@app/api/sas/sasDocumentoOrdemCompra'
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento'
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa'

interface Props {
    sasPropostaId: string
    sasProposta: ISasPropostaOrdemCompra
}

const ModalRecusaPropostaComercial = (props: Props) => {
    const { sasPropostaId, sasProposta } = props
    const [exibirModal, setExibirModal] = useState(false);

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);
    const [editando, setEditando] = useRecoilState(editandoState);

    const handleCancel = () => {
        setExibirModal(false)
    }

    const handleSubmit = (values: any) => {
        const form = new FormData()
        form.append('sasPropostaId', sasPropostaId)
        form.append('status', values.statusPropostaComercial)
        form.append('dataRecebimentoPropostaComercial', values.dataRecebimentoPropostaComercial)
        form.append('comentarioStatusPropostaComercial', values.comentarioStatusPropostaComercial)
        values.anexosPropostaComercial.map((c: any) => {
            form.append("anexosPropostaComercial", c);
        })

        if (editando.sasPropostaId == sasProposta.id) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }}
                />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise((resolve, reject) => {
                        updatePropostaComercial(form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    setReloadVendorList(!reloadVendorList);
                                    handleCancel()
                                    setModalAcoesId('')
                                    return resolve(true);
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao'
                                        })
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject(false);
                                        }
                                    }
                                }
                            })
                    })
                },
                onCancel: () => { setModalAcoesId('') }
            })
        } else {
            updatePropostaComercial(form)
                .then((data: any) => {
                    if (data && data.valid) {
                        setReloadVendorList(!reloadVendorList);
                        handleCancel()
                        setModalAcoesId('')
                    }
                })

        }
    }

    return (
        <Visibility visible={true}>
            <Tooltip title="Proposta Comercial Não Recebida">
                <Button icon='commons-cancel' onClick={() => { setExibirModal(true) }} />
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title="Proposta Comercial Não Recebida"
                    width="980px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key={`formPropostaComercial_${sasPropostaId}`}
                        initialValues={sasProposta}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <Visibility visible={
                                editando.sasPropostaId === sasProposta.id ||
                                (
                                    sasProposta.statusPropostaComercial !== 'Declinou' &&
                                    sasProposta.statusPropostaComercial !== 'Sem Resposta'
                                )
                            }>
                                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                            </Visibility>
                        ]}
                        validationSchema={Yup.object().shape({
                            dataRecebimentoPropostaComercial: Yup.string().required('O campo Data do Registro da Recusa é obrigatório.'),
                            statusPropostaComercial: Yup.string().required('O campo Motivo é obrigatório.'),
                            comentarioStatusPropostaComercial: Yup.string().required('O campo Justificativa é obrigatório.'),
                            anexosPropostaComercial: Yup.array().required('É necessário anexar no mínimo um arquivo.')
                        })}
                    >
                        <Row>
                            <FormDatePicker
                                label='Data do Registro da Recusa'
                                name='dataRecebimentoPropostaComercial'
                                format='DD/MM/YYYY'
                                span={6}
                                disabled={
                                    editando.sasPropostaId !== sasProposta.id &&
                                    (
                                        sasProposta.statusPropostaComercial === 'Declinou' ||
                                        sasProposta.statusPropostaComercial === 'Sem Resposta'
                                    )
                                }
                            />
                            <FormSelect
                                label='Motivo'
                                name='statusPropostaComercial'
                                options={[
                                    { text: 'Declínio', value: 'Declinou' },
                                    { text: 'Não Respondeu', value: 'Sem Resposta' }
                                ]}
                                span={6}
                                disabled={
                                    editando.sasPropostaId !== sasProposta.id &&
                                    (
                                        sasProposta.statusPropostaComercial === 'Declinou' ||
                                        sasProposta.statusPropostaComercial === 'Sem Resposta'
                                    )
                                }
                            />
                        </Row>
                        <Row>
                            <FormTextArea
                                label='Justificativa'
                                name='comentarioStatusPropostaComercial'
                                rows={3}
                                span={12}
                                disabled={
                                    editando.sasPropostaId !== sasProposta.id &&
                                    (
                                        sasProposta.statusPropostaComercial === 'Declinou' ||
                                        sasProposta.statusPropostaComercial === 'Sem Resposta'
                                    )
                                }
                            />
                        </Row>
                        <Row>
                            <UploadMultipleTableTmp
                                name='anexosPropostaComercial'
                                idDoComponente={`formPropostaComercialUpload_${sasPropostaId}`}
                                type='primary'
                                tablePagination={true}
                                onGetArquivos={async () => {
                                    return await getArquivosDocumentoOrdemCompraByOc({
                                        ordemCompraId: sasProposta.ordemCompraId,
                                        sasTipoDocumentoId: EGuidTipoSasDocumento.RecusaPropostaComercial,
                                        sasPropostaId: sasProposta.id,
                                        ordemCompraRodadaNegociacaoId: ordemCompraRodadaNegociacaoId
                                    }).then((data: any) => {
                                        return data || [];
                                    });
                                }}
                            />
                        </Row>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
    )
}

export default ModalRecusaPropostaComercial